import { ConfigurationPage } from './../configuration';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Uploads } from "../../services/uploads";
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationServices } from '../services';

/**
 * Generated class for the ConfigurationImagesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-images',
  templateUrl: 'configuration-images.html',
})
export class ConfigurationImagesPage {

  update_state: boolean = false;
  dish_uid: string;
  img_ref: string = null;
  selectedFiles: FileList;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public uploadServices: Uploads,
    private alertCtrl: AlertController,
    public globals: Globals,
    public translate: TranslateService,
    public configurationServices: ConfigurationServices) {
    this.globals.GAtrackView('Configuration', 'Configuration - Images - View', this.globals.restaurant.email, 'View', 'View Images', 'Configuration', '');
  }

  async selectFileLogo(event, type) {
    const file = event.target.files.item(0);
    if (file.type.match('image.*')) {
      this.selectedFiles = event.target.files;//File selected
      this.selectedFiles = this.globals.RenameFiles(this.selectedFiles, this.globals.restaurant_uid)
      //antes de subir la foto creamos el base64 de la imagen
      if (type == 'print') {
        if (file.type.match('image.png')) {
          this.getBase64(file).then(
            data => {
              this.globals.restaurant.logo_base64 = data.toString().replace(/^data:image\/(png|jpg);base64,/, "");
              //guardar en restaurante
              this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
                'logo_base64': this.globals.restaurant.logo_base64,
              });
            });
        } else {
          this.globals.launchToast(this.translate.instant('general-formato-invalido'), 3000, 'top');
          return;
        }
      }
      //
      this.img_ref = await this.uploadServices.uploadComplete(this.selectedFiles, 'logo') //Upload file to firbase storage
      this.updateLogo(type) //Update data to firestore
      this.globals.getLogoImageUrl(this.img_ref, type); //Get url from image uploaded
    } else {
      alert('invalid format!');
    }
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }


  updateLogo(type) {
    if (type === 'print') {
      this.globals.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'logo': this.img_ref,
      }).then(() => {
        //this.navCtrl.pop();
        this.globals.getLogoImageUrl(this.img_ref, type);
      });
    } else {
      this.globals.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'logo_share': this.img_ref,
      }).then(() => {
        //this.navCtrl.pop();
        this.globals.getLogoImageUrl(this.img_ref, type);
      });
    }
  }

  deleteLogo(type) {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-eliminar-imagen'),
      message: this.translate.instant('instant-seguro-quieres-eliminar-imagen'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.img_ref = null;
            if (type == 'share') {
              this.uploadServices.delete(this.globals.restaurant.logo_share);
              this.globals.logo_share_url = null;
            } else {
              this.uploadServices.delete(this.globals.restaurant.logo);
              this.globals.logo_url = null;
              this.updateLogoSunmiBase64();
            }
            this.updateLogo(type);
          }
        }
      ]
    });
    alert.present();

  }

  back() {
    this.globals.side_menu_config_active = '';
    if (this.navCtrl.canGoBack())
      this.navCtrl.pop();
    else
      this.navCtrl.setRoot(ConfigurationPage);
  }

  async selectFileRest(event) {
    const file = event.target.files.item(0)
    if (file.type.match('image.*')) {
      this.selectedFiles = event.target.files;//File selected
      this.selectedFiles = this.globals.RenameFiles(this.selectedFiles, this.globals.restaurant_uid)

      this.img_ref = await this.uploadServices.uploadComplete(this.selectedFiles, 'restaurants') //Upload file to firbase storage
      this.updateRest() //Update data to firestore
      this.globals.getRestImageUrl(this.img_ref); //Get url from image uploaded
    } else {
      alert('invalid format!');
    }
  }

  updateRest() {
    this.globals.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'image': this.img_ref,
    }).then(() => {
      //this.navCtrl.pop();
      //this.globals.getLogoImageUrl(this.img_ref)

    });
  }

  deleteRest() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-eliminar-imagen'),
      message: this.translate.instant('instant-seguro-quieres-eliminar-imagen'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.uploadServices.delete(this.globals.restaurant.image);
            this.globals.rest_image_url = null;
            this.img_ref = null;
            this.updateRest();
          }
        }
      ]
    });
    alert.present();

  }

  updateLogoSunmiBase64() {
    this.globals.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'logo_base64': this.img_ref,
    }).then(() => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-images/configuration-images.ts